var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatismo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 0C7.78646 0 6.66667 1.00781 6.66667 2.25V6H2.5C1.11979 6 0 7.00781 0 8.25V9.75C0 10.9922 1.11979 12 2.5 12H6.66667V21.75C6.66667 22.9922 7.78646 24 9.16667 24H10.8333C12.2135 24 13.3333 22.9922 13.3333 21.75V12H17.5C18.8802 12 20 10.9922 20 9.75V8.25C20 7.00781 18.8802 6 17.5 6H13.3333V2.25C13.3333 1.00781 12.2135 0 10.8333 0H9.16667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatismo);
export default __webpack_public_path__ + "static/media/Batismo.02bef50fb59f3ae368336fcf83674382.svg";
export { ForwardRef as ReactComponent };